import VueRouter from 'vue-router'
import Vue from 'vue'
import auth from './auth'
import home from './home'
import pages from './pages'

Vue.use(VueRouter)

const routes = [
  ...auth,
  ...home,
  ...pages,
]

const router = new VueRouter({
  mode: 'history',
  routes,
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

export default router
